import { Guid } from "@/types"
import { AssetOrigin } from "./Asset"

export enum EvaluationParameterFinanceCategory {
    investment = "investment",
    stock = "stock",
}

export enum EvaluationParameterIFRSDepreciationStart {
    firstMonth = "firstMonth",
    seventhMonth = "seventhMonth",
    never = "never",
}

export interface IGetEvaluationParameterDto {
    assetTypeName: string
    financeCategoryIFRS: EvaluationParameterFinanceCategory
    financeCategoryLocal: EvaluationParameterFinanceCategory
    ifrsDepreciationStart: EvaluationParameterIFRSDepreciationStart
    hasLocalDepreciation: boolean
    extraordinaryIFRS: number
    extraordinaryLocal: number
    residualValueIFRS: number
    residualValueLocal: number
}

export interface ICreateEvaluationParameterDto {
    assetTypeId: Guid
    assetOrigin: AssetOrigin
    financeCategoryIFRS: EvaluationParameterFinanceCategory
    financeCategoryLocal: EvaluationParameterFinanceCategory
    ifrsDepreciationStart: EvaluationParameterIFRSDepreciationStart
    hasLocalDepreciation: boolean
    extraordinaryIFRS: number
    extraordinaryLocal: number
    residualValueIFRS: number
    residualValueLocal: number
    assetCategoryId?: Guid
    divisionId?: Guid
}

export default class EvaluationParameter {
    assetTypeName: string
    financeCategoryIFRS: EvaluationParameterFinanceCategory
    financeCategoryLocal: EvaluationParameterFinanceCategory
    ifrsDepreciationStart: EvaluationParameterIFRSDepreciationStart
    hasLocalDepreciation: boolean
    extraordinaryIFRS: number
    extraordinaryLocal: number
    residualValueIFRS: number
    residualValueLocal: number

    constructor(dto: IGetEvaluationParameterDto) {
        this.assetTypeName = dto.assetTypeName
        this.financeCategoryIFRS = dto.financeCategoryIFRS
        this.financeCategoryLocal = dto.financeCategoryLocal
        this.ifrsDepreciationStart = dto.ifrsDepreciationStart
        this.hasLocalDepreciation = dto.hasLocalDepreciation
        this.extraordinaryIFRS = dto.extraordinaryIFRS
        this.extraordinaryLocal = dto.extraordinaryLocal
        this.residualValueIFRS = dto.residualValueIFRS
        this.residualValueLocal = dto.residualValueLocal
    }
}
